import { PlanProvider } from '@blocs.paywall';
import { gqlPlanTermEnum } from '@minecraft.graphql-types';
import { isBelowPremiumHeadshotsPlan, isFreeHeadshotsSubscriber } from './isFreeHeadshotsSubscriber';

type PaidTrialSubscription = {
  trialEndsAt?: string | null;
  plan?: {
    isBasePlan?: boolean | null;
    level?: number | null;
    provider?: string | null;
    term?: { code?: string | null } | null;
  } | null;
} | null;

const PAID_TRIAL_TERMS = [gqlPlanTermEnum.ANNUAL, gqlPlanTermEnum.MONTHLY];

/**
 * Annual or monthly Premium subscribers whose paid trial has not ended.
 * Plans below Premium use the free headshots modal.
 */
export const isPaidTrialSubscriber = (subscription?: PaidTrialSubscription): boolean => {
  const plan = subscription?.plan;
  const trialEndsAt = subscription?.trialEndsAt;

  if (
    !trialEndsAt ||
    !plan ||
    plan.isBasePlan ||
    isBelowPremiumHeadshotsPlan(plan) ||
    (plan.provider as PlanProvider | null) === PlanProvider.APPLE
  ) {
    return false;
  }

  if (!PAID_TRIAL_TERMS.includes(plan.term?.code as gqlPlanTermEnum)) {
    return false;
  }

  const trialEnd = new Date(trialEndsAt);

  return !Number.isNaN(trialEnd.getTime()) && trialEnd.getTime() > Date.now();
};

/**
 * Navigate to Headshots after the free upsell only when the purchased plan is
 * Premium and the paid trial has already ended. Essential, registration, and
 * in-trial Premium purchases stay ineligible.
 */
export const canScheduleHeadshotsAfterUpgrade = (subscription?: PaidTrialSubscription): boolean =>
  !isFreeHeadshotsSubscriber(subscription) && !isPaidTrialSubscriber(subscription);
